import defineComponent from 'flight';
import $ from 'static/script/libs/jquery';
import dummy from 'static/script/libs/owl.carousel.custom';
import breakpoints from 'static/script/utils/breakpoints';
import Spinner from 'static/script/libs/spin';

function ImageGalleryUI() {

    let paginationDots = '<div class="dot"><span></span></div>';

    this.defaultAttrs({
        item: '.image-gallery-item',
        image: '.product-image',
        unloadedImage: '.lazyOwl',
        loading: '.loading'
    });

    this.afterMove = function () {
        let currentItem = this.carousel.$userItems[this.carousel.currentItem];
        this.trigger(document, 'ui:carousel:after-move', { currentItem: currentItem });
        this.loadAllImages();
    };

    this.loadAllImages = function () {
        if (this.allImagesLoaded) {
            return;
        }

        let carousel = this.carousel;
        this.select('unloadedImage').each(function () {
            let $elm = $(this),
                $item = $elm.closest('.owl-item');
            carousel.lazyPreload($item, $elm);
        });

        this.allImagesLoaded = true;
    };

    this.updatePagination = function (item) {
        if (!breakpoints.isVisible(breakpoints.large)) {
            return paginationDots;
        }
        let thumb = $(item).data('thumb');
        let thumbHtml = thumb ? '<img src="' + thumb + '"/>' : '';
        return '<div class="thumb">' +
            thumbHtml +
            '</div>';
    };

    this.afterInit = function () {
        this.updateImages();
        this.select('loading').each(function () {
            new Spinner().spin(this);
        });
    };

    this.updateImages = function () {
        let imageAttribue = breakpoints.isVisible(breakpoints.large) ?
            'data-image-normal' :
            'data-image-small';
        this.select('image').each(function () {
            let $image = $(this),
                src = $image.attr(imageAttribue);
            if ($image.attr('data-src')) {
                $image.data('src', src);
                $image.attr('data-src', src);
            }
            if ($image.attr('src')) {
                $image.attr('src', src);
            }
        });
    };

    this.stopSpinners = function () {
        this.$node.find('.owl-item:not(.loading) .spinner').remove();
    };

    this._next = function () {
        this.$node.trigger('owl.next');
    };

    this._prev = function () {
        this.$node.trigger('owl.prev');
    };

    this._doTeardown = function () {
        let owl = this.carousel;
        if (owl && owl.destroy) {
            owl.destroy();
        }
    };

    this._keyboardNavigation = function (evt) {
        if (document.activeElement !== document.body) {
            return;
        }
        if (evt.keyCode === 37) {
            this._prev();
        }
        if (evt.keyCode === 39) {
            this._next();
        }
    };

    this.after('initialize', function () {
        this.updateImages();
        this.$node.owlCarousel({
            singleItem: true,
            pagination: true,
            navigation: true,
            lazyLoad: true,
            support3d: window.Feature.detected['hardware-acceleration-ok'],
            updatePagination: this.updatePagination.bind(this),
            afterInit: this.afterInit.bind(this),
            afterMove: this.afterMove.bind(this),
            afterUpdate: this.updateImages.bind(this),
            afterLazyLoad: this.stopSpinners.bind(this)
        });
        this.carousel = this.$node.data('owlCarousel');
        this.loadAllImages();
        this.on(document, 'ui:carousel:move-prev', this._prev);
        this.on(document, 'ui:carousel:move-next', this._next);
        this.on(document, 'ui:teardown', this._doTeardown);

        this.on(document, 'keyup', this._keyboardNavigation);

    });
}

module.exports = defineComponent.component(ImageGalleryUI);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/view-item/image-gallery.js